import './index.scss';

import { Component } from 'react';
import { BraxButton, BraxModal, BraxToastsType, BraxToasts, BraxTab, BraxTabs, BraxUncontrolledCheckboxField, BraxUncontrolledCheckboxFieldProps } from 'design-system';

import t from '../../utils/i18n';
import handleError from '../../utils/errors';
import { withContexts } from '../../utils/with-context';
import User from '../../view-model/users/User';
import usersService from '../../services/users';
import authService from '../../services/auth';
import UserContext from '../../contexts/User';

type TabId = 'termsOfUse' | 'privacyPolicy';

export type PoliciesUpdateProps = {
    toasts: BraxToastsType
    user: User,
    open?: boolean,
    onClose?: () => void
};

type PoliciesUpdateState = {
    loading: boolean,
    tab: TabId,
    // termsOfUseScrolled: boolean,
    termsOfUseAccepted: boolean,
    // privacyPolicyScrolled: boolean,
    privacyPolicyAccepted: boolean
};

export default withContexts({
    toasts: BraxToasts,
    user: UserContext
}, class PoliciesUpdate extends Component<PoliciesUpdateProps, PoliciesUpdateState> {

    state: PoliciesUpdateState = {
        loading: false,
        tab: 'termsOfUse',
        // termsOfUseScrolled: false,
        termsOfUseAccepted: false,
        // privacyPolicyScrolled: false,
        privacyPolicyAccepted: false
    };

    async accept() {
        this.setState({ loading: true });

        try {
            await usersService.acceptPolicies(this.props.user.id);

            await authService.updateUserInfo({ needAcceptPolicies: false });

            this.props.onClose?.();
        } catch (error) {
            this.props.toasts.create({ type: 'destructive', ...handleError(error) });

            this.setState({ loading: false });
        }
    }

    // handleIFrame(type: 'termsOfUse' | 'privacyPolicy', iframe: HTMLIFrameElement) {
    //     const key = `${type}Scrolled` as 'termsOfUseScrolled' | 'privacyPolicyScrolled';

    //     try {
    //         const frameWindow = iframe.contentWindow;

    //         if (!frameWindow)
    //             throw new Error('');

    //         frameWindow.addEventListener('scroll', () => {
    //             this.setState(prevState => {
    //                 const isScrolled = frameWindow.scrollY + frameWindow.innerHeight >= frameWindow.document.body.scrollHeight;

    //                 return !prevState[key] && isScrolled ? { [key]: true } as { [K in typeof key]: true } : null;
    //             });
    //         });
    //     } catch (error) {
    //         handleError(error);

    //         this.setState({ [key]: true } as { [K in typeof key]: true });
    //     }
    // }

    handleAccept() {
        if (this.state.tab === 'termsOfUse')
            this.setState({ tab: 'privacyPolicy' });
        else
            this.accept();
    }

    getCheckboxProps(): BraxUncontrolledCheckboxFieldProps {
        return this.state.tab === 'termsOfUse' ? {
            label: t('Eu li e aceito os termos de uso'),
            hint: t('Role a tela e leia até o final'),
            value: this.state.termsOfUseAccepted,
            // disabled: !this.state.termsOfUseScrolled,
            // status: !this.state.termsOfUseScrolled ? 'disabled' : undefined,
            onChange: (value: boolean) => this.setState({ termsOfUseAccepted: value })
        } : {
            label: t('Eu li e aceito as políticas de privacidade'),
            hint: t('Role a tela e leia até o final'),
            value: this.state.privacyPolicyAccepted,
            // disabled: !this.state.privacyPolicyScrolled,
            // status: !this.state.privacyPolicyScrolled ? 'disabled' : undefined,
            onChange: (value: boolean) => this.setState({ privacyPolicyAccepted: value })
        };
    }

    render() {
        return (
            <BraxModal
                open={this.props.open}
                className="policies-update"
                size="lg"
                close={false}
                backdrop={false}
                onClose={this.props.onClose}
            >
                <BraxTabs<TabId> active={this.state.tab} onTabChange={tab => this.setState({ tab })}>
                    <BraxTab<TabId> id="termsOfUse" title={t('Termos de Uso')} disabled>
                        <iframe
                            src="/terms.html"
                            title={t('Termos de Uso')}
                            // onLoad={event => this.handleIFrame('termsOfUse', event.target as HTMLIFrameElement)}
                        />
                    </BraxTab>

                    <BraxTab<TabId> id="privacyPolicy" title={t('Políticas de Privacidade')} disabled>
                        <iframe
                            src="/privacy.html"
                            title={t('Políticas de Privacidade')}
                            // onLoad={event => this.handleIFrame('privacyPolicy', event.target as HTMLIFrameElement)}
                        />
                    </BraxTab>
                </BraxTabs>

                <div>
                    <BraxUncontrolledCheckboxField {...this.getCheckboxProps()} />

                    <BraxButton
                        variant="primary"
                        disabled={
                            this.state.loading ||
                            (this.state.tab === 'termsOfUse' && !this.state.termsOfUseAccepted) ||
                            (this.state.tab === 'privacyPolicy' && !this.state.privacyPolicyAccepted)
                        }
                        onClick={() => this.handleAccept()}
                    >
                        { t(this.state.loading ? 'Salvando...' : 'Aceitar') }
                    </BraxButton>
                </div>
            </BraxModal>
        );
    }

});
